<template>
  <footer>
    <div class="row">
      <div class="col-md-6 col-sm-12">
        <span>
          QualiSurveyor, Version {{ env.VERSION }}
          <span v-if="env.GITREVISON"> / {{ env.GITREVISON }}</span>
        </span>
      </div>
      <div class="col-md-6 col-sm-12 text-right">
        <span @click="reloadApp" class="btn btn-sm btn-grey">Reload App</span>
        <span @click="goDebug" class="btn btn-sm btn-grey">Troubleshooting</span>
        <span @click="goDitoy" class="btn btn-sm btn-grey">Web App by ditoy</span>
      </div>
    </div>
  </footer>
</template>

<style scoped>
  .btn {
    cursor: pointer;
  }
</style>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'Footer',
    computed: {
      ...mapGetters({
        session: 'getSession'
      })
    },
    methods: {
      goDebug: function () {
        this.$router.push('/debug')
      },
      reloadApp: () => {
        window.location.reload(true)
      },
      goDitoy: () => {
        var win = window.open('https://www.ditoy.com', '_blank')
        win.focus()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue